import { BreadcrumbType } from "@/app/common/types/breadcrumb.type";
import { RequestActionType } from "@/app/common/types/requestAction.type";
import {
  AIRLINE_BTN_KEY,
  ASC_BTN_KEY,
  DPM_BTN_KEY,
  USER_BTN_KEY,
} from "@/app/const";

export const dashboardBreadcrumb: BreadcrumbType[] = [
  {
    title: "homepage-right",
    disabled: true,
  },
];

export const dashboardDetailBreadcrumb: BreadcrumbType[] = [
  {
    title: "homepage",
    disabled: false,
    to: "/",
  },
  {
    title: "homepage-detail",
    disabled: true,
  },
];

export const allNewsBreadcrumb: BreadcrumbType[] = [
  {
    title: "news",
    disabled: false,
    to: "/news",
  },
  {
    title: "news-all",
    disabled: true,
  },
];

export const newsDetailBreadcrumb: BreadcrumbType[] = [
  {
    title: "news",
    disabled: false,
    to: "/news",
  },
  {
    title: "news-detail",
    disabled: true,
  },
];

export const complaintBreadcrumb: BreadcrumbType[] = [
  {
    title: "complaint-page-right",
    disabled: true,
  },
];

export const complaintStatusBreadcrumb: BreadcrumbType[] = [
  {
    title: "",
    disabled: true,
    total: 0,
  },
];

export const adminFlightInfoBreadcrumb: BreadcrumbType[] = [
  {
    title: "admin",
    disabled: true,
  },
  {
    title: "admin-flight-information",
    disabled: true,
  },
];

export const adminUserManagementBreadcrumb: BreadcrumbType[] = [
  {
    title: "",
    disabled: true,
    total: 0,
  },
];

export const adminComplaintTopicBreadcrumb: BreadcrumbType[] = [
  {
    title: "admin",
    disabled: true,
  },
  {
    title: "admin-complaint-topic",
    disabled: true,
  },
];

export const adminRequestManagementBreadcrumb: BreadcrumbType[] = [
  {
    title: "",
    disabled: true,
    total: 0,
  },
];

export const complaintDetailBreadcrumb: BreadcrumbType[] = [
  {
    title: "complaint-flight-information",
    disabled: false,
    active: true,
    stepNo: 1,
    goToStep: 1,
  },
  {
    title: "complaint-passenger-information",
    disabled: false,
    active: false,
    stepNo: 2,
    goToStep: 2,
  },
  {
    title: "complaint-topic",
    disabled: false,
    active: false,
    stepNo: 3,
    goToStep: 3,
  },
];

export const complaintRequestBreadcrumb: RequestActionType[] = [
  // {
  //   key: USER_BTN_KEY.RESEND,
  //   title: "action-resend",
  //   disabled: false,
  //   txtColor: "white",
  //   btnColor: "primary",
  //   callBackFn: "doSendRequestAgain",
  //   appendIcon: "mdi mdi-send-outline",
  //   iconColor: "white",
  // },
  {
    key: USER_BTN_KEY.SAVE,
    title: "action-send-additional-doc",
    disabled: false,
    txtColor: "white",
    btnColor: "primary",
    callBackFn: "doUserSave",
    appendIcon: "mdi mdi-send-outline",
    iconColor: "white",
  },
  {
    key: USER_BTN_KEY.CANCEL,
    title: "action-cancel",
    disabled: false,
    txtColor: "white",
    btnColor: "error",
    callBackFn: "doCancelRequest",
    prependIcon: "mdi mdi-close",
    iconColor: "white",
  },
];

export const ascRequestBreadcrumb: RequestActionType[] = [
  {
    key: ASC_BTN_KEY.EXPORT,
    title: "action-export-pdf",
    disabled: false,
    txtColor: "primary",
    btnColor: "white",
    callBackFn: "doExportPdf",
    prependIcon: "mdi mdi-file-download-outline",
    iconColor: "primary",
  },
  {
    key: ASC_BTN_KEY.HISTORY,
    title: "action-history",
    disabled: false,
    txtColor: "primary",
    btnColor: "white",
    callBackFn: "viewHistory",
    prependIcon: "mdi mdi-format-list-bulleted",
    iconColor: "primary",
  },
  {
    key: ASC_BTN_KEY.NEED_DOC,
    title: "action-need-more-doc",
    disabled: false,
    txtColor: "white",
    btnColor: "primary",
    callBackFn: "doNeedAdditionalDocs",
    prependIcon: "mdi mdi-file-document-plus-outline",
    iconColor: "white",
  },
  {
    key: ASC_BTN_KEY.ASSIGN_DPM,
    title: "action-assign-dpm",
    disabled: false,
    txtColor: "white",
    btnColor: "primary",
    callBackFn: "doSendToDepartment",
    prependIcon: "mdi mdi-send-outline",
    iconColor: "white",
  },
  {
    key: ASC_BTN_KEY.VERIFY_DOC,
    title: "action-verify-doc",
    disabled: false,
    txtColor: "white",
    btnColor: "primary",
    callBackFn: "doVerifyAdditionalDocs",
    prependIcon: "mdi mdi-text-box-search-outline",
    iconColor: "white",
  },
  {
    key: ASC_BTN_KEY.SAVE,
    title: "action-save",
    disabled: false,
    txtColor: "white",
    btnColor: "primary",
    callBackFn: "doAscSave",
    prependIcon: "mdi mdi-content-save-outline",
    iconColor: "white",
  },
  {
    key: ASC_BTN_KEY.SEND_DOC,
    title: "action-send-doc-to-dpm",
    disabled: false,
    txtColor: "white",
    btnColor: "primary",
    callBackFn: "doSendDocsToDepartment",
    prependIcon: "mdi mdi-send-outline",
    iconColor: "white",
  },
  {
    key: ASC_BTN_KEY.END,
    title: "action-cancel-complaint",
    disabled: false,
    txtColor: "white",
    btnColor: "error",
    callBackFn: "doNotifyCancelRequest",
    prependIcon: "mdi mdi-close",
    iconColor: "white",
  },
];

export const dpmRequestBreadcrumb: RequestActionType[] = [
  {
    key: DPM_BTN_KEY.EXPORT,
    title: "action-export-pdf",
    disabled: false,
    txtColor: "primary",
    btnColor: "white",
    callBackFn: "doExportPdf",
    prependIcon: "mdi mdi-file-download-outline",
    iconColor: "primary",
  },
  {
    key: DPM_BTN_KEY.HISTORY,
    title: "action-history",
    disabled: false,
    txtColor: "primary",
    btnColor: "white",
    callBackFn: "viewHistory",
    prependIcon: "mdi mdi-format-list-bulleted",
    iconColor: "primary",
  },
  {
    key: DPM_BTN_KEY.SEND_ASC,
    title: "action-send-to-asc",
    disabled: false,
    txtColor: "white",
    btnColor: "primary",
    callBackFn: "doSendBackToAsc",
    prependIcon: "mdi mdi-arrow-u-left-top",
    iconColor: "white",
  },
  {
    key: DPM_BTN_KEY.SUMMARY,
    title: "action-summary",
    disabled: false,
    txtColor: "white",
    btnColor: "primary",
    callBackFn: "doSummaryOfOperation",
    prependIcon: "mdi mdi-emoticon-happy-outline",
    iconColor: "white",
  },
  {
    key: DPM_BTN_KEY.NEED_DOC,
    title: "action-need-more-doc",
    disabled: false,
    txtColor: "white",
    btnColor: "primary",
    callBackFn: "doNeedAdditionalDocs",
    prependIcon: "mdi mdi-file-document-plus-outline",
    iconColor: "white",
  },
  {
    key: DPM_BTN_KEY.SAVE,
    title: "action-save",
    disabled: false,
    txtColor: "white",
    btnColor: "primary",
    callBackFn: "doDpmSave",
    prependIcon: "mdi mdi-content-save-outline",
    iconColor: "white",
  },
  {
    key: DPM_BTN_KEY.SEND_AIRLINE,
    title: "action-send-to-airline",
    disabled: false,
    txtColor: "white",
    btnColor: "primary",
    callBackFn: "doSendToAirline",
    prependIcon: "mdi mdi-send-outline",
    iconColor: "white",
  },
];

export const airlineRequestBreadcrumb: RequestActionType[] = [
  {
    key: AIRLINE_BTN_KEY.EXPORT,
    title: "action-export-pdf",
    disabled: false,
    txtColor: "primary",
    btnColor: "white",
    callBackFn: "doExportPdf",
    prependIcon: "mdi mdi-file-download-outline",
    iconColor: "primary",
  },
  {
    key: AIRLINE_BTN_KEY.SAVE,
    title: "action-save",
    disabled: false,
    txtColor: "white",
    btnColor: "primary",
    callBackFn: "doAirlineSave",
    prependIcon: "mdi mdi-content-save-outline",
    iconColor: "white",
  },
  {
    key: AIRLINE_BTN_KEY.RETURN,
    title: "action-return-to-dpm",
    disabled: false,
    txtColor: "white",
    btnColor: "primary",
    callBackFn: "doReturnToDepartment",
    prependIcon: "mdi mdi-arrow-u-left-top",
    iconColor: "white",
  },
  {
    key: AIRLINE_BTN_KEY.SUBMIT,
    title: "action-submit-to-dpm",
    disabled: false,
    txtColor: "white",
    btnColor: "primary",
    callBackFn: "doSubmitToDepartment",
    prependIcon: "mdi mdi-send-outline",
    iconColor: "white",
  },
];
